// extracted by mini-css-extract-plugin
export default {"root":"Description_root__4iSty","label_container":"Description_label_container__Cwpio"};